var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BackgroundCommand } from '@reference-data/background-message-key.enum';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import Config from 'src/config';
import LocalStorageUtils from 'src/utils/localStorage.utils';
const getClaims = (username) => __awaiter(void 0, void 0, void 0, function* () {
    const values = yield LocalStorageUtils.getMultipleValueFromLocalStorage([
        LocalStorageKeyEnum.CLAIM_ACCOUNTS,
        LocalStorageKeyEnum.CLAIM_REWARDS,
        LocalStorageKeyEnum.CLAIM_SAVINGS,
    ]);
    const accountValue = values[LocalStorageKeyEnum.CLAIM_ACCOUNTS]
        ? values[LocalStorageKeyEnum.CLAIM_ACCOUNTS][username]
        : false;
    const rewardValue = values[LocalStorageKeyEnum.CLAIM_REWARDS]
        ? values[LocalStorageKeyEnum.CLAIM_REWARDS][username]
        : false;
    const savingsValue = values[LocalStorageKeyEnum.CLAIM_SAVINGS]
        ? values[LocalStorageKeyEnum.CLAIM_SAVINGS][username]
        : false;
    return {
        [LocalStorageKeyEnum.CLAIM_ACCOUNTS]: accountValue,
        [LocalStorageKeyEnum.CLAIM_REWARDS]: rewardValue,
        [LocalStorageKeyEnum.CLAIM_SAVINGS]: savingsValue,
    };
});
const saveClaims = (claimRewards, claimAccount, claimSavings, username) => __awaiter(void 0, void 0, void 0, function* () {
    let allRewards = yield AutomatedTasksUtils.getAllClaimRewards();
    let allAccounts = yield AutomatedTasksUtils.getAllClaimAccounts();
    let allSavings = yield AutomatedTasksUtils.getAllClaimSavings();
    allRewards = allRewards !== null && allRewards !== void 0 ? allRewards : {};
    allAccounts = allAccounts !== null && allAccounts !== void 0 ? allAccounts : {};
    allSavings = allSavings !== null && allSavings !== void 0 ? allSavings : {};
    allRewards = Object.assign(Object.assign({}, allRewards), { [username]: claimRewards });
    allAccounts = Object.assign(Object.assign({}, allAccounts), { [username]: claimAccount });
    allSavings = Object.assign(Object.assign({}, allSavings), { [username]: claimSavings });
    LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.CLAIM_REWARDS, allRewards);
    LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.CLAIM_ACCOUNTS, allAccounts);
    LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.CLAIM_SAVINGS, allSavings);
    chrome.runtime.sendMessage({
        command: BackgroundCommand.UPDATE_CLAIMS,
        value: {
            claimRewards: allRewards,
            claimAccounts: allAccounts,
            claimSavings: allSavings,
        },
    });
});
const getAllClaimAccounts = () => __awaiter(void 0, void 0, void 0, function* () {
    return yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.CLAIM_ACCOUNTS);
});
const getAllClaimRewards = () => __awaiter(void 0, void 0, void 0, function* () {
    return yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.CLAIM_REWARDS);
});
const getAllClaimSavings = () => __awaiter(void 0, void 0, void 0, function* () {
    return yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.CLAIM_SAVINGS);
});
const initBackgroundClaims = () => __awaiter(void 0, void 0, void 0, function* () {
    let allRewards = yield AutomatedTasksUtils.getAllClaimRewards();
    let allAccounts = yield AutomatedTasksUtils.getAllClaimAccounts();
    let allSavings = yield AutomatedTasksUtils.getAllClaimSavings();
    chrome.runtime.sendMessage({
        command: BackgroundCommand.UPDATE_CLAIMS,
        value: {
            claimRewards: allRewards,
            claimAccounts: allAccounts,
            claimSavings: allSavings,
        },
    });
});
const updateClaim = (username, enabled, claimType) => __awaiter(void 0, void 0, void 0, function* () {
    let claims = yield LocalStorageUtils.getValueFromLocalStorage(claimType);
    claims = Object.assign(Object.assign({}, claims), { [username]: enabled });
    LocalStorageUtils.saveValueInLocalStorage(claimType, claims);
});
const canClaimSavingsErrorMessage = (activeAccount) => {
    if (!activeAccount.keys.active) {
        return 'popup_html_need_active_key_for_claim_savings';
    }
};
const canClaimRewardsErrorMessage = (activeAccount) => {
    if (!activeAccount.keys.posting) {
        return 'popup_html_need_posting_key_to_claim_rewards';
    }
};
const canClaimAccountErrorMessage = (activeAccount) => {
    if (!activeAccount.keys.active) {
        return 'popup_html_need_active_key_for_claim_savings';
    }
    else if (activeAccount.rc.max_mana < Config.claims.freeAccount.MIN_RC) {
        return 'popup_html_not_enough_rc_to_claim_account';
    }
};
const getUsernameAutoStake = (username) => __awaiter(void 0, void 0, void 0, function* () {
    const autoStake = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.LAYER_TWO_AUTO_STAKE);
    return autoStake && autoStake[username] ? true : false;
});
const saveUsernameAutoStake = (username, value) => __awaiter(void 0, void 0, void 0, function* () {
    const autoStake = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.LAYER_TWO_AUTO_STAKE);
    let autoStakeUsers = autoStake !== null && autoStake !== void 0 ? autoStake : {};
    if (Object.keys(autoStakeUsers).length > 0) {
        autoStakeUsers[username] = value;
    }
    else {
        autoStakeUsers = Object.assign(Object.assign({}, autoStakeUsers), { [username]: value });
    }
    LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.LAYER_TWO_AUTO_STAKE, autoStakeUsers);
});
const getUsernameAutoStakeList = (username) => __awaiter(void 0, void 0, void 0, function* () {
    const autoStakeList = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.LAYER_TWO_AUTO_STAKE_TOKENS);
    return autoStakeList && autoStakeList[username]
        ? autoStakeList[username]
        : [];
});
const updateAutoStakeTokenList = (username, list) => __awaiter(void 0, void 0, void 0, function* () {
    const reMappedList = list.map((c) => {
        return { symbol: c.value.symbol };
    });
    const currentList = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.LAYER_TWO_AUTO_STAKE_TOKENS);
    let autoStakeList = currentList !== null && currentList !== void 0 ? currentList : {};
    if (Object.keys(autoStakeList).length > 0) {
        autoStakeList[username] = reMappedList;
    }
    else {
        autoStakeList = Object.assign(Object.assign({}, autoStakeList), { [username]: reMappedList });
    }
    LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.LAYER_TWO_AUTO_STAKE_TOKENS, autoStakeList);
});
const AutomatedTasksUtils = {
    getClaims,
    saveClaims,
    initBackgroundClaims,
    getAllClaimAccounts,
    getAllClaimRewards,
    getAllClaimSavings,
    updateClaim,
    canClaimSavingsErrorMessage,
    canClaimAccountErrorMessage,
    canClaimRewardsErrorMessage,
    getUsernameAutoStake,
    saveUsernameAutoStake,
    updateAutoStakeTokenList,
    getUsernameAutoStakeList,
};
export default AutomatedTasksUtils;
